import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.css';

const Index = ({
  handleSubmitRequest,
  setIsOpenName,
  setGuests,
  isActive,
  isActive_,
  setIsActive_,
  setIsActive,
  disabled = false
}) => {
  const [countdown, setCountdown] = useState(10);
  const inactivityTimer = useRef(null);
  const countdownTimer = useRef(null);
  const disabledRef = useRef(disabled);

  // Обновляем ref при изменении disabled
  useEffect(() => {
    disabledRef.current = disabled;

    // Останавливаем все таймеры когда disabled
    if (disabled) {
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
        inactivityTimer.current = null;
      }
      if (countdownTimer.current) {
        clearInterval(countdownTimer.current);
        countdownTimer.current = null;
      }
      setIsActive(true);
      setCountdown(10);
    }
  }, [disabled, setIsActive]);

  // Функция сброса таймера активности
  const resetTimer = () => {
    if (disabledRef.current) return;

    setIsActive(true);
    setCountdown(10);

    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }

    inactivityTimer.current = setTimeout(() => {
      if (disabledRef.current) return;
      setIsActive(false);
      startCountdown();
    }, 60000);
  };

  // Функция для начала отсчета при отсутствии активности
  const startCountdown = () => {
    if (disabledRef.current) return;

    setCountdown(10);

    if (countdownTimer.current) {
      clearInterval(countdownTimer.current);
    }

    countdownTimer.current = setInterval(() => {
      if (disabledRef.current) {
        clearInterval(countdownTimer.current);
        return;
      }

      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(countdownTimer.current);
          setIsActive(false);
          handleSubmitRequest('cancel');
          setIsOpenName(false);
          setGuests('');
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Эффект для отслеживания активности
  useEffect(() => {
    const handleActivity = () => {
      resetTimer();
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('click', handleActivity);

    resetTimer();

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('click', handleActivity);
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }
      if (countdownTimer.current) {
        clearInterval(countdownTimer.current);
      }
    };
  }, []);

  // Не показываем таймер если disabled
  if (disabled) return null;

  return (
    <>
      {!isActive && countdown > 0 && (
        <div className={styles.wrapper}>
          <p className={styles.timer}>{countdown}</p>
        </div>
      )}
    </>
  );
};

export default Index;
